import React from 'react';
import { gql } from '@apollo/client';
import { AdminEntityMergeRequestItemProps } from '../../AdminEntityMergeRequestItem';
import {
  EntityTypeEnum,
  MergeItemSiteContactValueFragment,
} from '../../../../../../../../../gql/typings';
import AdminMergeItemContactValue, {
  AdminMergeItemContactValue_FRAGMENT,
} from '../../shared/ContactValue/AdminMergeItemContactValue';

const AdminMergeItemSiteContactValue: React.FC<AdminEntityMergeRequestItemProps> = (props) => {
  const info = props.item.type as MergeItemSiteContactValueFragment;
  return (
    <AdminMergeItemContactValue
      {...props}
      entityType={EntityTypeEnum.SITE}
      entityAffiliationWinnerId={props.into.id}
      value1={info.loserValue}
      value2={info.winnerValue}
    />
  );
};

gql`
  fragment MergeItemSiteContactValue on SiteContactValue_EntityDataToBeTransferredType {
    code
    loserValue { ...ContactValueInfo }
    winnerValue { ...ContactValueInfo }
  }

  ${AdminMergeItemContactValue_FRAGMENT}`;

export default AdminMergeItemSiteContactValue;
